import { render, staticRenderFns } from "./ServerErrorPage500.vue?vue&type=template&id=665c473c"
import script from "./ServerErrorPage500.vue?vue&type=script&lang=js"
export * from "./ServerErrorPage500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports